export const hasErrors = <O extends object>(errors: O): boolean =>
  Object.values(errors).some(e => (typeof e === 'object' ? hasErrors(e) : Boolean(e)));

export const setError = <O extends object>(errors: O, field: string, message?: string) => ({
  ...errors,
  [field]: message ?? true,
});

export const unsetError = <O extends object>(errors: O, field: string) => ({
  ...errors,
  [field]: false,
});

export const checkField = <O extends object>(errors: O, field: string, condition: boolean, message?: string) =>
  condition ? setError(errors, field, message) : unsetError(errors, field);
